import {
  captureException,
  flush,
  init,
  replayIntegration,
} from "@sentry/react";

export function initSentry() {
  init({
    dsn: "https://ac942dae298e85962e4853f332a4cead@o4509321669574656.ingest.de.sentry.io/4509321897050192",
    enabled:
      import.meta.env.PUBLIC_ENVIRONMENT === "production" ||
      import.meta.env.PUBLIC_ENVIRONMENT === "staging",
    environment: import.meta.env.PUBLIC_ENVIRONMENT,
    integrations: [
      replayIntegration({
        blockAllMedia: false,
      }),
    ],
    replaysOnErrorSampleRate: 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    sendDefaultPii: true,
  });
}

type CaptureExceptionInfo = Parameters<typeof captureException>[1];

export const recordErrorInSentry = (
  error: unknown,
  info: CaptureExceptionInfo = {}
) => {
  const flushTimeout = 2000;
  let sentryError: Error;

  if (error instanceof Error) {
    sentryError = error;
  } else if (typeof error === "string") {
    sentryError = new Error(error);
  } else {
    console.error(error);
    throw new Error(`Unknown error thrown${JSON.stringify(error)}`);
  }

  if (import.meta.env.PUBLIC_ENVIRONMENT !== "local") {
    captureException(sentryError, info);
    flush(flushTimeout);
  }
};
